import Backbone from 'backbone';
import _ from 'underscore';

export default Backbone.View.extend({

  template: require('./transitStopsIW.hbs'),

  /**
   * Create a new TransitStopsIW instance
   * @memberOf module:Views
   * @class TransitStopsIW
   * @classdesc Infowindow to chow all information related to the transit stops.
   * @extends Backbone.View
   * @param {object} options - The needed config to fill the template
   */
  constructor(options = {}) {
    this.options = options;
    this.templateConfig = {};
    Backbone.View.prototype.constructor.call(this);
  },

  /**
   * Initialize the infowindow
   * @memberOf module:Views.TransitStopsIW
   * @function
   */
  initialize(config) {
    Backbone.View.prototype.initialize.call(this, config);
    _.extend(this.templateConfig, this.options);
    this.render();
  },

  /**
   * Render the template
   * @memberOf module:Views.TransitStopsIW
   * @function
   * @returns {TransitStopsIW} the instance
   */
  render() {
    this.setElement(this.template(this.templateConfig));
    return this;
  }
});



// WEBPACK FOOTER //
// ./lmm-widget/src/views/transitStopsIW/transitStopsIW.js